import React from "react";
import { graphql } from "gatsby";
import classNames from "classnames";
import Layout from "../components/Layout";
import { YoastSeo } from "../components/SEO";
import CommonHeader from "../components/CommonHeader";
import { SEARCH_EXCLUDE_CLASSNAME } from "../components/SearchIndex";
import { EmployeeTile } from "../components/Tile";
import BlockButton from "../components/BlockButton";

const Employees = ({ data: { page, randomEmployees } }) => {
  return (
    <Layout dark={false}>
      <YoastSeo title={page.title} yoast={page.yoast_head} />
      <CommonHeader title={page.title} subtitle={page.content} />
      <div
        className={classNames(
          SEARCH_EXCLUDE_CLASSNAME,
          "relative z-20 mt-12 w-full bg-brand-gray"
        )}
      >
        <div className="container grid grid-cols-2 gap-6 py-12 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
          {randomEmployees.map((employee, i) => (
            <EmployeeTile key={i} employee={employee} headerType="h2" />
          ))}
        </div>
      </div>
      <section className="container relative bg-white md:block">
        <div className="mx-auto flex w-full max-w-screen-md flex-col items-center space-y-6 py-12">
          <h2 className="text-3xl">{page?.pageEmployees?.footerTitle}</h2>
          <div
            className="content text-center text-2xl"
            dangerouslySetInnerHTML={{
              __html: page?.pageEmployees?.footerSubtitle,
            }}
          />
          <BlockButton
            href={page?.pageEmployees?.footerButtonLink?.uri}
            title={page?.pageEmployees?.footerButtonText}
          />
        </div>
      </section>
    </Layout>
  );
};

export default Employees;

export const query = graphql`
  query ($id: String!) {
    page: wpPage(id: { eq: $id }) {
      title
      content
      seo {
        fullHead
      }
      pageEmployees {
        footerTitle
        footerSubtitle
        footerButtonText
        footerButtonLink {
          ... on WpPage {
            uri
          }
        }
      }
    }
    randomEmployees {
      ...EmployeeTile
    }
  }
`;
